/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileJarShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="M9.795 16.84v-.919c.197.085.371.148.523.188.156.04.304.06.442.06.487 0 .73-.234.73-.703V13l-.89-.288v-.583h1.936v3.43c0 .487-.143.865-.43 1.133-.28.268-.676.402-1.185.402-.206 0-.409-.022-.61-.067a1.72 1.72 0 0 1-.516-.188zm3.02.16 1.849-4.87h1.012L17.538 17h-1.166l-.321-.998h-1.796l-.321.998zm1.722-1.883h1.226l-.617-1.916zM18.06 17v-4.87h1.869c.58 0 1.027.133 1.34.401.312.268.469.648.469 1.14 0 .343-.09.636-.268.877a1.417 1.417 0 0 1-.744.516L21.946 17h-1.153l-1.032-1.749-.663-.167V17zm1.038-2.6h.509c.406 0 .688-.05.844-.154.16-.107.241-.292.241-.556 0-.263-.08-.446-.24-.55-.157-.106-.439-.16-.845-.16h-.51zM2.474 17.474 1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileJarShortcut as FileJarShortcut };
